
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">My Tasks</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">My Tasks</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filteredTasks.length" (onChange)="onListControlsChange($event)"></list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col" style="padding: 0 2rem;">
      <div class="row" *ngFor="let task of displayedTasks">
        <div class="col card-item workflow-step-bar-large">
          <div class="step-status-icon"><span class="step-status-icon black oi oi-arrow-right font-18" [hidden]="task.status != &quot;In Progress&quot;"></span><span class="step-status-icon green oi oi-check font-18" [hidden]="task.status != &quot;Completed&quot;"></span><span class="step-status-icon red oi oi-minus font-18" [hidden]="task.status != &quot;Blocked&quot;"></span></div>
          <div class="step-info p-extra-margin">
            <role-block [roles]="task.roles"></role-block>
            <h4><a [href]="task.url">{{ task.readableStepName }}</a></h4>
            <h4><span>{{ task.readableTargetType }}: </span><a [href]="'/' + task.targetType + '?id=' + task.targetId">{{ task.targetName }}</a></h4>
            <p *ngIf="task.targetType !== &quot;project&quot; &amp;&amp; task.projectId"><span>Project: </span><a [href]="'/project?id=' + task.projectId">{{ task.projectName }}</a></p>
            <p *ngIf="task.lastUpdate">{{ task.lastUpdate | date: 'medium' }}</p>
            <p *ngIf="task.lastUpdateName">{{ task.lastUpdateName }} <a class="email-link oi oi-envelope-closed" *ngIf="task.lastUpdateEmail" [href]="'mailto:' + task.lastUpdateEmail"></a>
            </p>
          </div><a class="step-link-container" [href]="task.url"><span class="oi oi-chevron-right"></span></a>
        </div>
      </div>
      <div class="row" *ngIf="displayedTasks.length === 0">
        <div class="col">
          <div class="card-item">
            <p class="text-center empty-table-message">There are no tasks waiting for your action.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>